import * as _m0 from "protobufjs/minimal";
import { SubmitSurveyRequest, SubmitSurveyResponse } from '../submitsurvey';
import { withAuthRetry } from '../utils/authRetry';

export async function submitsurvey(request: SubmitSurveyRequest, accessToken: string, setAccessToken: (token: string | null) => void, logout: () => void): Promise<SubmitSurveyResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const encodedRequest = SubmitSurveyRequest.encode(request).finish();
        const base64 = _m0.util.base64.encode(encodedRequest, 0, encodedRequest.length);

        const params = new URLSearchParams(window.location.search);
        const staging = params.get('stagingEnv')?.toLowerCase() === 'true';

        let url = "https://li68ja5qo4.execute-api.us-west-2.amazonaws.com/intakeservice/submitsurvey";
        if (staging) {
            url = `${url}-staging`;
        }

        const response = await fetch(
            url, {
            method: 'POST',
            headers,
            body: base64,
        }
        );
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): SubmitSurveyResponse => {
        return SubmitSurveyResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}